import React, { useState, useRef, useEffect } from 'react';

import fileDownload from 'js-file-download'

import ColumnLayout from '../layouts/ColumnLayout';
import OrderTableComponent from '../components/OrderTableComponent';
import OrderComponent from '../components/OrderComponent';

import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { createOrderApi, exportOrderApi, importOrderApi } from '../services/OrderService';

export default function Orders() {
  const [reloadRows, setReloadRows] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [importFile, setImportFile] = useState(false);

  const hiddenFileInput = useRef();

  const saveHandler = async (event) => {
    const rest = await createOrderApi(localStorage.getItem('token'), localStorage.getItem('user_id'), event)
      .then((data) => {
        setReloadRows(true);
        return [true, data];
      }).catch((errors) => {
        return [false, errors];
      });
    return rest;
  };

  const exportHandler = async () => {
    const rest = await exportOrderApi(localStorage.getItem('token'), localStorage.getItem('user_id'))
      .then(async (data) => {
        var filename = data.headers.get('content-disposition').split(' ')[1].split('=')[1].split('"')[1];
        data.blob().then(blob => fileDownload(blob, filename))
      }).catch((errors) => {
        return errors
      });
    return rest;
  };

  const handleImportClick = event => {
    hiddenFileInput.current.click();
  };

  const handleChange = event => {
    setSelectedFile(event.target.files[0]);
    setImportFile(true);
  };

  const cleanImportFile = () => {
    hiddenFileInput.current.value = "";
    setSelectedFile(null);
    setImportFile(false);
  }

  const importHandler = async () => {
    const rest = await importOrderApi(localStorage.getItem('token'), localStorage.getItem('user_id'), selectedFile)
      .then(async (data) => {
        return true;
      }).catch((errors) => {
        return errors
      });
    return rest;
  };

  useEffect(() => {
    if (importFile) {
      async function postData() {
        const rest = await importHandler();
        cleanImportFile();
        setReloadRows(true);
      }
      postData();
    }
  }, [importFile])

  return (
    <div>
      <ColumnLayout childs={[
        (<h1>Ordenes Judiciales Policiales</h1>),
        (<OrderTableComponent reloadRows={reloadRows} onSetReloadRows={setReloadRows} />),
        // TODO: Use the nested GRID please findout an easy way to send it through props...
        (<input
          type="file"
          ref={hiddenFileInput}
          onChange={handleChange}
          style={{display: 'none'}}
        />),
        ([<Button variant="contained" endIcon={<FileUploadIcon />} sx={{marginRight: 2, marginTop: 2 }} onClick={handleImportClick}>Import</Button>,
          <Button variant="contained" endIcon={<DownloadIcon />} sx={{ marginTop: 2 }} onClick={exportHandler}>Export</Button>]),
        (<OrderComponent onSave={saveHandler} />)
      ]} />
    </div>
  );
}
